import React from "react";
import { Link } from "react-router-dom";
import { portfolioCompanies } from "../data/mockData";
import "./Portfolio.css";

const Portfolio = () => {
  return (
    <div className="portfolio-page">
      <section className="section-padding">
        <div className="container">
          <div className="page-header">
            <h1 className="hero-medium">Our Companies</h1>
            <p className="body-large">
              Each company in our portfolio solves a real problem for a real community.
              We build, own, and operate — no outside investors calling the shots,
              no exit timelines, no growth-at-all-costs pressure.
            </p>
          </div>

          <div className="portfolio-list">
            {portfolioCompanies.map((company, index) => (
              <Link
                key={company.id}
                to={`/portfolio/${company.slug}`}
                className="portfolio-card-link"
              >
                <div className="portfolio-card">
                  <span className="portfolio-number">{index + 1}</span>
                  <div className="portfolio-card-body">
                     <div className="portfolio-card-top">
                       <h2 className="heading-2">{company.tagline}</h2>
                       <span className="category-badge">{company.category}</span>
                     </div>
                    <p className="body-small company-short-desc">{company.description}</p>
                  </div>
                  <span className="portfolio-arrow">&rarr;</span>
                </div>
              </Link>
            ))}
          </div>

          {/* Our Model */}
          <div className="portfolio-model">
            <h2 className="heading-2">Our Model</h2>
            <p className="body-regular">
              Every company we build is designed to work on its own — but they're
              stronger together. Shared infrastructure, cross-promotion between
              communities, and a single team that actually cares about the product.
              We're not a portfolio of bets. We're a family of tools built by the
              same people, for people who deserve better software.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
